import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { SystemsState, SystemDefinition } from '../state/system.state';
import { selectObservedSystemsWithMultipleObservers } from '../selectors/system.selectors';

@Injectable({
  providedIn: 'root',
})
export class SystemObserverService {

  constructor(private store: Store<SystemsState>) {}

  getSystemsWithMultipleObservers(): Observable<SystemDefinition[]> {
    return this.store.select(selectObservedSystemsWithMultipleObservers);
  }
}
